import { motion } from 'motion/react'

export function ProgressBar({
  completed,
  total,
  position = 'bottom',
  style = 'thin',
}: {
  completed: number
  total: number
  position?: 'top' | 'bottom'
  style?: 'thin' | 'thick' | 'text'
}) {
  const percent = total === 0 ? 0 : Math.round((completed / total) * 100)

  if (style === 'text') {
    return (
      <div
        className="fixed right-4 rounded-full px-3 py-1 text-sm font-medium shadow-sm"
        style={{
          [position]: '1rem',
          background: 'color-mix(in srgb, var(--form-bg,#F8FAFC) 88%, white)',
          color: 'var(--form-answer,#64748B)',
        }}
      >
        {percent}%
      </div>
    )
  }

  return (
    <div
      className="fixed inset-x-0 z-20"
      style={{
        [position]: 0,
        background: 'color-mix(in srgb, var(--form-accent,#6366F1) 14%, transparent)',
      }}
    >
      <motion.div
        className={
          style === 'thin'
            ? 'h-1 bg-[var(--form-accent,#6366F1)]'
            : 'h-2 bg-[var(--form-accent,#6366F1)]'
        }
        animate={{ width: `${percent}%` }}
      />
      <div className="sr-only">
        {completed} / {total}
      </div>
    </div>
  )
}
